export const REQUEST_METRICS_TOO_AGGRESSIVE = "02ffedf4-4690-11e9-82f6-0242ac120002";
export const SPONSORSHIP_ISSUES = "266982b6-4690-11e9-82f6-0242ac120002";
export const BUSINESS_PLAN = "3883ebf9-4690-11e9-82f6-0242ac120002";
export const OTHER = "5cd9ffd2-4690-11e9-82f6-0242ac120002";
export const LOAN_TOO_LARGE = "6c5b0727-468f-11e9-82f6-0242ac120002";
export const LOAN_TOO_SMALL = "6f53028e-468f-11e9-82f6-0242ac120002";
export const UNRESPONSIVE = "787c0374-4690-11e9-82f6-0242ac120002";
export const ASSET_CLASS_TYPE = "7b95bd32-468f-11e9-82f6-0242ac120002";
export const LOCATION_SUBMARKET = "85e2ecaf-468f-11e9-82f6-0242ac120002";
export const PRODUCTION_TARGETS_HIT = "89078579-4690-11e9-82f6-0242ac120002";
export const PRICING_NOT_COMPETITIVE = "fa11fa92-468f-11e9-82f6-0242ac120002";

export const passReasonList = [
  { name: "Loan too large", value: LOAN_TOO_LARGE },
  { name: "Loan too small", value: LOAN_TOO_SMALL },
  { name: "Asset Class/Type", value: ASSET_CLASS_TYPE },
  { name: "Location/Submarket", value: LOCATION_SUBMARKET },
  { name: "Pricing not competitive", value: PRICING_NOT_COMPETITIVE },
  { name: "Request metrics too aggressive", value: REQUEST_METRICS_TOO_AGGRESSIVE },
  { name: "Sponsorship issues", value: SPONSORSHIP_ISSUES },
  { name: "Production targets hit", value: PRODUCTION_TARGETS_HIT },
  { name: "Business plan", value: BUSINESS_PLAN },
  { name: "Other", value: OTHER },
  { name: "Unresponsive", value: UNRESPONSIVE }
];
